import { API_BASE } from "./api";

// Client for dubu-api's bridge-quote endpoint (auth-gated; cookies carry the session).
// Non-custodial: the response includes a ready-to-sign transaction_request that the USER's
// wallet signs, our backend only quotes.

export type BridgeChain = "ETHEREUM" | "POLYGON" | "BASE" | "OPTIMISM" | "BSC" | "SOLANA";
export type BridgeToken = "USDT" | "USDC";

export const BRIDGE_CHAINS: { id: BridgeChain; label: string; evm: boolean }[] = [
  { id: "POLYGON", label: "Polygon", evm: true },
  { id: "BASE", label: "Base", evm: true },
  { id: "OPTIMISM", label: "Optimism", evm: true },
  { id: "BSC", label: "BNB Chain", evm: true },
  { id: "ETHEREUM", label: "Ethereum", evm: true },
  { id: "SOLANA", label: "Solana", evm: false },
];

export interface BridgeQuote {
  tool: string;
  from: { chain: BridgeChain; token: BridgeToken; amount: string | null };
  to: {
    chain: BridgeChain;
    token: BridgeToken;
    amount: string | null;
    amount_min: string | null;
  };
  eta_seconds: number;
  fees_usd: string;
  gas_usd: string;
  approval_address: string | null;
  source: {
    chain_id: number | null;
    token_address: string;
    amount_minor: string;
    decimals: number;
  };
  transaction_request: {
    to?: string;
    data?: string;
    value?: string;
    gasLimit?: string;
    gasPrice?: string;
    chainId?: number;
  } | null;
}

export interface BridgeQuoteParams {
  from_chain: BridgeChain;
  to_chain: BridgeChain;
  token: BridgeToken;
  amount: number;
  from_address: string;
  to_address: string;
}

export const fetchBridgeQuote = async (params: BridgeQuoteParams): Promise<BridgeQuote> => {
  const res = await fetch(`${API_BASE}/pro/bridge/quote`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params),
  });
  const body = await res.json().catch(() => null);
  if (res.status === 401) throw new Error("Sign in with your wallet to get bridge quotes");
  if (!res.ok || !body?.success) throw new Error(body?.message || "Quote failed");
  return body.data as BridgeQuote;
};
